import React from "react";

import { cn } from "@utils/utils";

interface DonutChartLoaderProps {
  className?: string;
}
const DonutChartLoader: React.FC<DonutChartLoaderProps> = ({ className }) => {
  return (
    <div
      className={cn(
        "h-full container flex p-10 justify-center items-center",
        className,
      )}
    >
      <div className="h-40 w-40 border-8 border-secondary rounded-full animate-pulse"></div>
    </div>
  );
};

export default DonutChartLoader;
